<tt-page>
    <tt-page-heading>{{ webpageHeading }}</tt-page-heading>
    <tt-project [params]="params" (getLoaded)="setHeading($event)" (submit)="onSubmit()" style="max-width: 180rem"></tt-project>
</tt-page>
